module.exports = __webpack_public_path__ + "img/slide_item_1.f006f6d1.png";